<template>
    <div class="">
        <Header></Header>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="handleBack">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>

                <div class="card-container" style="height: 216px;">
                    <div class="card-wrapper">
                        <div class="card-header" style="color: #121212;">
                            {{ basicInfo.planName }}
                        </div>
                        <div class="statistical-report-container">
                            <div class="statistical-report-line"></div>
                            <div class="statistical-left-wrapper">
                                <div class="statistical-title-wrapper">
                                    <div v-if="basicInfo.planStatus == 0" class="statistical-status0">未开始</div>
                                    <div v-if="basicInfo.planStatus == 1" class="statistical-status1">进行中</div>
                                    <div v-if="basicInfo.planStatus == 2" class="statistical-status2">已结束</div>
                                    <div class="statistical-title">统计周期</div>
                                </div>
                                <div class="statistical-date-wrapper">
                                    <div class="statistical-start-date">
                                        <img src="@/assets/img/start.png" alt="" class="statistical-date-img">
                                        <span class="statistical-date-label">
                                            {{ basicInfo.planStartTime }}
                                        </span>
                                    </div>
                                    <div class="statistical-end-date">
                                        <img src="@/assets/img/end.png" alt="" class="statistical-date-img">
                                        <span class="statistical-date-label">
                                            {{ basicInfo.planEndTime }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="statistical-data-wrapper">
                                <div class="statistical-data-item">
                                    <div class="statistical-data-label">实时参与人数</div>
                                    <div class="statistical-data-value">{{ basicInfo.joinCount }}</div>
                                </div>
                                <div class="statistical-data-item">
                                    <div class="statistical-data-label">完成人数</div>
                                    <div class="statistical-data-value">{{ basicInfo.finishedCount }}</div>
                                </div>
                                <div class="statistical-data-item">
                                    <div class="statistical-data-label">计划总人数</div>
                                    <div class="statistical-data-value">{{ basicInfo.totalCount }}</div>
                                </div>
                                <div class="statistical-data-item">
                                    <div class="statistical-data-label">完成率</div>
                                    <div class="statistical-data-value">{{ basicInfo.finishedRate }}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-container" style="height: 424px;">
                    <div class="card-wrapper">
                        <div class="card-header">
                            统计数据
                            <div class="statistical-report-line"></div>
                        </div>
                        <div class="card-cherts-wrapper">
                            <div id="card-cherts" class="card-cherts"></div>
                            <div class="card-cherts-btn-wrapper">
                                <div class="card-cherts-btn-part">
                                    <div v-for="(item, key) in sysChartsData" :key="key" class="card-cherts-state">
                                        <div class="card-cherts-state-rect" :style="{ background: item.color }"></div>
                                        <div class="card-cherts-state-label">
                                            <span v-if="item.status == 1">未开始</span>
                                            <span v-if="item.status == 2">进行中</span>
                                            <span v-if="item.status == 3">已完成</span>
                                            <span v-if="item.status == 4">到期未完成</span>
                                            <span class="card-cherts-state-num">{{ item.count }}</span>
                                            <span>人</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-cherts-btn-part">
                                    <div v-for="(item, key) in sysChartsData" :key="key" class="card-cherts-btn-item">
                                        <div v-if="item.enableClick" class="card-cherts-btn"
                                            @click="viewEchartsDetail(item.status)">详情</div>
                                        <div v-else class="card-cherts-btn">详情</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card-container" style="padding-bottom:80px;">
                    <div class="card-wrapper">
                        <div class="card-header">
                            测评数据
                            <div class="statistical-report-line"></div>
                        </div>
                        <div class="measure-search-wrapper">
                            <div class="measure-search">
                                <el-select v-model="searchMeasure" placeholder="阶段测评" @change="changeMeasure"
                                    style="width:280px;">
                                    <el-option label="阶段测试" value="part"></el-option>
                                    <el-option label="综合测试" value="total"></el-option>
                                </el-select>
                            </div>
                            <div class="measure-search" style="margin-left:15px;">
                                <el-select v-model="searchPaper" placeholder="" @change="changePaper" style="width:280px;">
                                    <el-option v-for="item in paperOptions" :key="item.metaExamId"
                                        :label="item.metaExamName" :value="item.metaExamId">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="measure-header-wparrer">
                            <div class="measure-header-item">
                                <div class="measure-header-label">计划考试人数</div>
                                <div class="measure-header-value">{{ planInfo.totalCount }}</div>
                            </div>
                            <div class="measure-header-item">
                                <div class="measure-header-label">实时参与人数</div>
                                <div class="measure-header-value">{{ planInfo.joinCount }}</div>
                            </div>
                            <div class="measure-header-item">
                                <div class="measure-header-label">考试次数</div>
                                <div class="measure-header-value">{{ planInfo.examTimes }}</div>
                            </div>
                            <div class="measure-header-item">
                                <div class="measure-header-label">平均分</div>
                                <div class="measure-header-value">{{ planInfo.avgScore }}</div>
                            </div>
                            <div class="measure-header-item">
                                <div class="measure-header-label">平均考试时长</div>
                                <div class="measure-header-value">{{ resetTimes(planInfo.avgTime) }}</div>
                            </div>
                        </div>
                        <div class="achievements-wrap">
                            <el-select v-model="achievements" placeholder="" @change="changeAchievements"
                                style="width:280px;">
                                <el-option v-for="item in achievementsOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="people-num-wrap">
                                <span class="people-num-box">{{ tableData.length }}</span><span>人</span>
                            </div>
                        </div>
                        <div class="measure-table-wrapper">
                            <div class="measure-table-item">
                                <div class="measure-table-header row1 row-first">
                                    名次
                                    <i id="tableIcon-number" class="el-icon-caret-bottom table-icon"
                                        @click="changeRange('number')"></i>
                                </div>
                                <div class="measure-table-header row1">
                                    姓名
                                </div>
                                <div class="measure-table-header row1">
                                    考试次数
                                    <i id="tableIcon-examTimes" class="el-icon-caret-bottom table-icon"
                                        @click="changeRange('examTimes')"></i>
                                </div>
                                <div class="measure-table-header row1">
                                    分数
                                    <i id="tableIcon-score" class="el-icon-caret-bottom table-icon"
                                        @click="changeRange('score')"></i>
                                </div>
                                <div class="measure-table-header row2">
                                    做题时长
                                    <i id="tableIcon-userSpendTime" class="el-icon-caret-bottom table-icon"
                                        @click="changeRange('userSpendTime')"></i>
                                </div>
                                <div class="measure-table-header row3">
                                    最近一次考试时间
                                </div>
                                <div class="measure-table-header row1 row-last">
                                    操作
                                </div>
                            </div>
                            <div v-for="(item, index) in tableData" :key="'table-' + index" class="measure-table-item">
                                <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                    {{ item.number }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                    {{ item.userName }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                    {{ item.examTimes }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row1' : 'measure-table-row row1'">
                                    {{ item.score }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row2' : 'measure-table-row row2'">
                                    {{ resetTimes(item.userSpendTime) }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row3' : 'measure-table-row row3'">
                                    {{ item.lastExamTime }}
                                </div>
                                <div :class="index % 2 == 1 ? 'measure-table-color row1 table-operate' : 'measure-table-row row1 table-operate'"
                                    @click="viewMeasureDetail(item)">
                                    详情
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <el-dialog title="" :show-close="true" width="1250px" top="57px" :visible.sync="echartsDialog"
            class="dialog-container">
            <div class="dialog-header">
                <div>{{ echartsDialogTitle }}</div>
            </div>
            <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div class="dialog-search-wrapper">
                        <el-input v-model="echartSearchVal" aria-placeholder="输入成员姓名/电话">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                        <div class="search-btn" @click="searchEchartSearchList">搜索</div>
                    </div>

                    <div class="table-container">
                        <div class="table-wrapper">
                            <table border>
                                <tr class="table-header">
                                    <td>姓名</td>
                                    <td>手机号</td>
                                    <td style="width:40%;">所属公司部门</td>
                                    <td>操作</td>
                                </tr>
                                <tr v-for="(item, key) in echartDetailList" :key="key">
                                    <td>{{ item.userName }}</td>
                                    <td>{{ item.mobile }}</td>
                                    <td>{{ item.deptName }}</td>
                                    <td class="echartDetailBtn" @click="viewReportDetail(item)">查看报告</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </el-dialog>

        <el-dialog title="" :show-close="true" width="1200px" top="57px" :visible.sync="recordDialog"
            class="dialog-container">
            <div class="dialog-header">
                <div>考试记录</div>
            </div>
            <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div class="table-container">
                        <div class="table-wrapper">
                            <table border>
                                <tr class="table-header">
                                    <td>考试次数</td>
                                    <td>考试分数</td>
                                    <td>做题时长</td>
                                    <td style="width:40%;">交卷时间</td>
                                </tr>
                                <tr v-for="(item, index) in recordDetailList" :key="'examRecord-' + index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.userScore }}</td>
                                    <td>{{ resetTimes(item.userSpendTime) }}</td>
                                    <td>{{ item.userExamEndTime }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {
    planStatisticsBasicInfo,
    planStatisticsEcharts,
    planTestStatisticsData,
    partTestList,
    totalPlanList,
    examStatisticsList,
    planStudyUserList,
    stageExamRecordList,
    examRecordList
} from '@/api/index.js';
export default {
    name: '',
    components: {
        Header
    },
    data() {
        return {
            dept: '',
            token: '',
            planId: '',
            basicInfo: {},
            searchMeasure: 'part',
            measureOptions: [],
            searchPaper: '',
            paperOptions: [],
            planInfo: {
                avgScore: 0,
                avgTime: 0,
                examTimes: 0,
                joinCount: 0,
                totalCount: 0
            },
            tableData: [],
            range: {
                number: true,
                examTimes: true,
                score: true,
                userSpendTime: true
            },
            echartsDialog: false,
            echartsDialogTitle: '计划未开始成员',
            echartSearchVal: '',
            echartDetailList: [],
            echartsPage: 1,
            recordDialog: false,
            recordDetailList: [],
            sysChartsData: [],
            achievements: 0,
            achievementsOptions: [
                {
                    label: '全部',
                    value: 0,
                },
                {
                    label: '未及格',
                    value: 1,
                },
                {
                    label: '已及格',
                    value: 2,
                },
                {
                    label: '未作答',
                    value: 3,
                },
            ],
            oldSearchData: {
                metaExamId: null,
                type: null,
            }
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.planId = this.$route.params.id;
        window.localStorage.setItem('plan', JSON.stringify({ id: this.planId }));
        this.getBasicInfo();
        this.getChartData();
        this.getPartTest();
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
            //  this.$router.push('/studyplan/manage-plan');
        },
        getBasicInfo() {
            planStatisticsBasicInfo(this.planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.basicInfo = res.data;
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        getChartData() {
            planStatisticsEcharts(this.planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.dataList;
                    var newArr = [];
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        var newRow = item;
                        switch (item.status) {
                            case 1:
                                newRow["name"] = "未开始";
                                newRow["value"] = item.rate;
                                break;
                            case 2:
                                newRow["name"] = "进行中";
                                newRow["value"] = item.rate;
                                break;
                            case 3:
                                newRow["name"] = "已完成";
                                newRow["value"] = item.rate;
                                break;
                            case 4:
                                newRow["name"] = "到期未完成";
                                newRow["value"] = item.rate;
                                break;
                        }
                        newArr.push(newRow);
                        if (i == data.length - 1) {
                            this.chartInit(newArr);
                        }
                    }
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        chartInit(yData) {
            var corlorArr = ["rgb(255,180,123)", "rgb(15,108,245)", "rgb(85,167,255)", "rgb(163,163,163)"];
            var labelArr = ["未开始", "进行中", "已完成", "到期未完成"];
            var myChart = this.$echarts.init(document.getElementById('card-cherts'));
            myChart.setOption({
                title: {
                    text: "完成状态",
                    left: "19.5%",
                    top: "40%",
                    textStyle: {
                        color: "#303B45",
                        fontSize: 18,
                        align: "center"
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} {b}: {c}%'
                },
                color: corlorArr,
                legend: [
                    {
                        show: false,
                        orient: 'vertical',
                        itemHeight: 16,
                        itemWidth: 16,
                        selectedMode: false,
                        data: labelArr,
                        textStyle: {
                            color: '#303B45',
                            fontSize: '20'
                        },
                        left: 'left',
                        padding: [30, 0, 0, 550],
                        itemGap: 50
                    }
                ],
                grid: {
                    left: '0px',
                    right: '0px',
                    bottom: '0',
                    top: '30px',
                    containLabel: true
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['40%', '85%'],
                        center: ["28%", "45%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'inner'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '18',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: yData,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter: '{d}%',
                                    position: 'inner',
                                    fontSize: '18',
                                    color: '#fff'
                                },
                                labelLine: {
                                    show: true
                                }
                            }
                        }
                    }
                ]
            }, true);
            this.echartsLabel(corlorArr, yData);
        },
        echartsLabel(corlorArr, yData) {
            var newArr = [];
            for (var i = 0; i < yData.length; i++) {
                var item = yData[i];
                item['color'] = corlorArr[i];
                newArr.push(item);
                if (i == yData.length - 1) {
                    this.sysChartsData = newArr;
                }
            }
        },
        getPlanBasic(params) {
            planTestStatisticsData({
                "deptId": 0,
                "metaExamId": params.metaExamId,
                "planId": this.planId,
                "type": params.type,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.planInfo = res.data;
                    this.getExamStatisticsList(params);
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        resetTimes(time) {
            var hours = parseInt(time / 3600);
            var hoursRum = time % 3600;
            var minutes = parseInt(hoursRum / 60);
            var seconds = hoursRum % 60;
            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return `${hours}:${minutes}:${seconds}`;
        },
        getPartTest() {
            partTestList(this.planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.paperOptions = data;
                    if (data.length > 0) {
                        var defaultData = data[0];
                        this.searchPaper = defaultData['metaExamId'];
                        var params = {
                            type: 1,
                            metaExamId: defaultData['metaExamId']
                        };
                        this.oldSearchData.type = params.type
                        this.oldSearchData.metaExamId = params.metaExamId
                        this.getPlanBasic(params);
                    }
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        getTotalTest() {
            totalPlanList(this.planId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.paperOptions = data;
                    if (data.length > 0) {
                        var defaultData = data[0];
                        this.searchPaper = defaultData['metaExamId'];
                        var params = {
                            type: 2,
                            metaExamId: defaultData['metaExamId']
                        };
                        this.oldSearchData.type = params.type
                        this.oldSearchData.metaExamId = params.metaExamId
                        this.getPlanBasic(params);
                    }
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        changeMeasure(params) {
            switch (params) {
                case 'part':
                    this.getPartTest();
                    break;
                case 'total':
                    this.getTotalTest();
                    break;
            }
        },
        changePaper(id) {
            var testMode = this.searchMeasure;
            var params = {};
            switch (testMode) {
                case 'part':
                    params = {
                        type: 1,
                        metaExamId: id
                    };
                    break;
                case 'total':
                    params = {
                        type: 2,
                        metaExamId: id
                    };
                    break;
            }
            this.oldSearchData.type = params.type
            this.oldSearchData.metaExamId = params.metaExamId
            this.getPlanBasic(params);
        },
        getExamStatisticsList(params) {
            examStatisticsList({
                "deptId": 0,
                "metaExamId": params.metaExamId,
                "planId": this.planId,
                "type": params.type,
                "userId": 0,
                "filterType": this.achievements
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.tableData = data;
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        changeRange(target) {
            var range = this.range;
            var activeRow = range[target];
            var targetDom = document.getElementById(`tableIcon-${target}`);
            if (activeRow) {
                targetDom.style.transform = 'rotate(-180deg)';
                this.range[target] = false;
            } else {
                targetDom.style.transform = 'rotate(0deg)';
                this.range[target] = true;
            }
            this.rankTableData(target, activeRow);
        },
        rankTableData(target, mode) {
            var tableData = this.tableData;
            var _this = this;
            this.tableData = tableData.sort(_this.compareArr(target, mode));
        },
        compareArr(property, mode) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                var newVal;
                if (!mode) {
                    newVal = value1 - value2;
                } else {
                    newVal = value2 - value1;
                }
                return newVal;
            }
        },
        viewEchartsDetail(num) {
            this.echartSearchVal = '';
            this.echartsPage = 1;
            this.activeEchartsMode = num;
            switch (num) {
                case 1: this.echartsDialogTitle = '计划未开始成员'; break;
                case 2: this.echartsDialogTitle = '计划进行中成员'; break;
                case 3: this.echartsDialogTitle = '计划已完成成员'; break;
                case 4: this.echartsDialogTitle = '计划到期未完成成员'; break;
            }
            this.getPlanStudyUserList();
        },
        searchEchartSearchList() {
            this.echartsPage = 1;
            this.getPlanStudyUserList();
        },
        getPlanStudyUserList() {
            planStudyUserList({
                "deptId": 0,
                "keyword": this.echartSearchVal,
                "pageNum": this.echartsPage,
                "pageSize": 10000,
                "planId": this.planId,
                "status": this.activeEchartsMode,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.echartDetailList = data.list;
                    this.echartsDialog = true;
                }
                return;
            }).catch(err => {
             //   console.log(err);
            });
        },
        viewMeasureDetail(row) {
            var mode = this.searchMeasure;
            switch (mode) {
                case 'part':
                    stageExamRecordList(row.metaExamId, row.userId, {}, {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.recordDetailList = data;
                            this.recordDialog = true;
                        }
                        return;
                    }).catch(err => {
                     //   console.log(err);
                    });
                    break;
                case 'total':
                    examRecordList(row.metaExamId, row.userId, {}, {
                        Authorization: this.token,
                        DeptId: this.dept
                    }).then(res => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.recordDetailList = data;
                            this.recordDialog = true;
                        }
                        return;
                    }).catch(err => {
                     //   console.log(err);
                    });
                    break;
            }
        },
        viewReportDetail(row) {
            this.$router.push(`/memberInfo/echarts-report/${row.userId}/${row.deptId}/${this.dept}`);
        },
        // 改变成绩情况
        changeAchievements() {
            let params = {
                type: this.oldSearchData.type,
                metaExamId: this.oldSearchData.metaExamId,
            };
            this.getExamStatisticsList(params);
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    margin: 0 auto;
}

.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    padding: 100px;
}

.page-back-wrapper {
    width: 100%;
    height: 68px;
    background: #ffffff;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #f0f0f3;
    display: flex;
    align-items: center;
    margin-top: 18px;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.card-container {
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #EAEAEA;
    display: flex;
    margin-top: 18px;
    position: relative;
}

.card-wrapper {
    flex: 1;
    margin: 30px 45px 0px 45px;
}

.card-header {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    position: relative;
}

.statistical-report-container {
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
    position: relative;
}

.statistical-report-line {
    width: 6px;
    height: 24px;
    background: #3E63EE;
    border-radius: 3px;
    position: absolute;
    left: -45px;
    top: 5px;
}

.statistical-status0 {
    width: 72px;
    height: 24px;
    background: #9B9FAA;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.statistical-status1 {
    width: 72px;
    height: 24px;
    background: #FF9645;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.statistical-status2 {
    width: 72px;
    height: 24px;
    background: #67C23A;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.statistical-title-wrapper {
    display: flex;
    align-items: center;
}

.statistical-title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    margin-left: 10px;
}

.statistical-date-wrapper {
    display: flex;
    margin-top: 25px;
}

.statistical-start-date {
    display: flex;
    align-items: center;
}

.statistical-end-date {
    display: flex;
    align-items: center;
    margin-left: 17px;
}

.statistical-date-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
    margin-left: 6px;
}

.statistical-date-img {
    width: 20px;
    height: 20px;
}

.statistical-data-wrapper {
    display: flex;
}

.statistical-data-item {
    margin-left: 70px;
}

.statistical-data-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
}

.statistical-data-value {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303B45;
    margin-top: 6px;
}

.card-cherts-wrapper {
    display: flex;
}

.card-cherts {
    width: 500px;
    height: 300px;
    margin-left: 50px;
}

.card-cherts-btn-wrapper {
    flex: 1;
    margin-top: 15px;
    display: flex;
}

.card-cherts-state {
    display: flex;
    align-items: center;
}

.card-cherts-state-num {
    color: #FF9645;
    margin: 0px 5px 0px 5px;
}

.card-cherts-state-rect {
    width: 15px;
    height: 15px;
    margin-right: 8px;
}

.card-cherts-btn-part {
    flex: 1;
    height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-cherts-btn {
    width: 88px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid #4F79ED;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4F79ED;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.card-cherts-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff;
}

.measure-search-wrapper {
    display: flex;
    margin-top: 17px;
}

.measure-header-wparrer {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.achievements-wrap {
    margin-top: 17px;
}

.people-num-wrap {
    display: inline-block;
}

.people-num-wrap .people-num-box {
    color: #409eff;
    margin-left: 16px;
}

.measure-header-item {
    flex: 1;
}

.measure-header-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
}

.measure-header-value {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #121212;
    margin-top: 6px;
}

.measure-table-wrapper {
    width: 100%;
    margin-top: 50px;
    background: #fff;
}

.measure-table-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.measure-table-header {
    height: 64px;
    background: #FFBA85;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
}

.measure-table-row {
    height: 64px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
    background: #F8F8F8;
}

.measure-table-color {
    height: 64px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2px;
    background: #FFE5D1;
    ;
}

.row1 {
    flex: 1;
}

.row2 {
    flex: 1.5;
}

.row3 {
    flex: 2;
}

.row-first {
    border-radius: 16px 0px 0px 0px;
}

.row-last {
    border-radius: 0px 16px 0px 0px;
}

.table-icon {
    color: #333333;
    margin-left: 3px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.table-icon:hover {
    cursor: pointer;
    opacity: 0.8;
}

.table-operate {
    color: #4F79ED;
    cursor: pointer;
}

.dialog-container>>>.el-dialog__body {
    padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-content>>>.el-form-item__label {
    text-align: left !important;
    font-size: 16px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}

.dialog-content>>>.el-input__inner {
    height: 40px !important;
    background: #FFFFFF !important;
    border-radius: 6px !important;
    border: 1px solid #D9D9D9 !important;
}

.dialog-header {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-left: 45px;
    padding-top: 32px;
}

.dialog-content-wrapper {
    display: flex;
}

.dialog-content {
    flex: 1;
    margin: 20px 40px 40px 40px;
}

.dialog-search-wrapper {
    display: flex;
    justify-content: space-between;
}

.search-btn {
    width: 92px;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #C1C1C1;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 16px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.search-btn:hover {
    cursor: pointer;
    color: #3E63EE;
    border: solid #3E63EE 1px;
}

.table-container {
    width: 100%;
}

.table-wrapper {
    width: 100%;
    margin-top: 34px;
}

table {
    width: 100%;
    border: 1px solid #CBCBCB;
    border-collapse: collapse;
}

td {
    height: 60px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    text-align: center;
}

.table-header td {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    background: rgb(248, 248, 248);
}

.echartDetailBtn {
    color: #3E63EE;
}

.echartDetailBtn:hover {
    cursor: pointer;
    opacity: 0.8;
}
</style>


